import React from 'react';

const SupportHero = () => {
  return (
    <section className="px-6 py-20 max-w-7xl mx-auto">
      <div className="text-center">
        <span className="text-blue-600 font-semibold text-sm uppercase tracking-wider">Support Center</span>
        <h1 className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-blue-900 via-blue-700 to-purple-700 bg-clip-text text-transparent mb-6 mt-4">
          How Can We Help You?
        </h1>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
          Find answers to common questions or reach out to our team
        </p>
      </div>
    </section>
  );
};

export default SupportHero;